import type { ReactNode } from 'react';
import { HoverCardWithText } from '@/common/components/shared/hover-card';
import { EMPTY_DEFAULT } from '@/common/components/shared/table';

interface Props {
  label: string;
  value: ReactNode | (() => ReactNode);
  hoverCardContent?: string;
}

export const Detail = ({ label, value, hoverCardContent }: Props) => (
  <div className="mb-2 flex flex-wrap text-sm">
    <div className="!w-[120px] text-gray-500">{label}</div>
    <div className="ml-2">
      <HoverCardWithText disabled={!hoverCardContent} hoverCardContent={hoverCardContent}>
        {(typeof value === 'function' ? value() : value) || EMPTY_DEFAULT}
      </HoverCardWithText>
    </div>
  </div>
);
